import { render, staticRenderFns } from "./SignedUpForWaitingListIcon.vue?vue&type=template&id=5097ecd4&"
import script from "./SignedUpForWaitingListIcon.vue?vue&type=script&lang=js&"
export * from "./SignedUpForWaitingListIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports